var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppGallery = function SvgAppGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    fillRule: "evenodd",
    d: "M15.935 3H8.063C4.355 3 3 4.356 3 8.063v7.874C3 19.644 4.355 21 8.063 21h7.872C19.642 21 21 19.644 21 15.937V8.063C20.997 4.356 19.642 3 15.935 3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.557 12.004h.479v2.263h-.48v-.92H5.479v.92H5v-2.263h.478v.913h1.079zM9.25 13.3c0 .368-.191.564-.536.564s-.539-.202-.539-.58v-1.28h-.478V13.3c0 .64.368 1.001 1.011 1.001s1.02-.372 1.02-1.02V12H9.25zm5.525.26-.534-1.556h-.391l-.536 1.556-.523-1.555h-.51l.822 2.262h.396l.536-1.485.535 1.485h.4l.82-2.262h-.496zm1.874-.267h.87v-.411h-.87v-.464h1.263v-.412h-1.735v2.26h1.777v-.413H16.65zm1.878.97H19v-2.259h-.472zm-7.854-.468-.214.47h-.488l1.038-2.26h.422l1.034 2.26h-.501l-.212-.47zm.177-.408h.72l-.363-.81zM11.998 9.5A3.497 3.497 0 0 1 8.5 6h.495a3.008 3.008 0 0 0 4.17 2.835A3.005 3.005 0 0 0 15.005 6h.495a3.5 3.5 0 0 1-3.502 3.5"
  })));
};
export default SvgAppGallery;